/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Organization
 */
export interface Organization {
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    parent_id?: string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    org_name: string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    tenant_name: string;
}

/**
 * Check if a given object implements the Organization interface.
 */
export function instanceOfOrganization(value: object): value is Organization {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('org_name' in value) || value['org_name'] === undefined) return false;
    if (!('tenant_name' in value) || value['tenant_name'] === undefined) return false;
    return true;
}

export function OrganizationFromJSON(json: any): Organization {
    return OrganizationFromJSONTyped(json, false);
}

export function OrganizationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Organization {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'parent_id': json['parent_id'] == null ? undefined : json['parent_id'],
        'org_name': json['org_name'],
        'tenant_name': json['tenant_name'],
    };
}

export function OrganizationToJSON(json: any): Organization {
    return OrganizationToJSONTyped(json, false);
}

export function OrganizationToJSONTyped(value?: Organization | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'parent_id': value['parent_id'],
        'org_name': value['org_name'],
        'tenant_name': value['tenant_name'],
    };
}

